import VideoSrcsetComponent from '../video-srcset/video-srcset'
import Component from '../../lib/component'
import { RootComponent } from '../../main'

export default class HeroComponent extends Component {
    static selector () {
        return '.hero'
    }

    constructor (opts) {
        super(opts)

        this.init = true

        this.render()

        if (document.visibilityState !== 'hidden')
            this.renderIntro()

        this.listen()
    }

    listen () {
        this.on('resize', () => this.render())
        this.on('resize:debounced', () => this.render())

        if ((RootComponent.Scroller || {}).state)
            RootComponent.Scroller.state
                .on('update', () => this.render())

        if (!this.el.classList.contains('hero-intro'))
            return

        if (!this.props.introAnimation)
            document
                .addEventListener('visibilitychange', () =>
                    document.visibilityState !== 'hidden'
                            && !this.props.introAnimation
                        ? this.renderIntro()
                        : null)

        if (this.getFeature('touch'))
            return

        this.getIntroHoverAnchors()
            .forEach((el) => {
                const hoverItem = this.el
                    .querySelector(`.hero-intro-media [data-type=${
                        el.getAttribute('data-type')}`)

                if (!hoverItem)
                    return

                if (hoverItem.querySelector('video'))
                    hoverItem.querySelector('video').load()

                el.addEventListener('mouseenter', (e) => {
                    this.onIntroHoverAnchorsMouseEnter(e)

                    const onMouseLeave = (e) => {
                        el.removeEventListener('mouseleave', onMouseLeave)

                        setTimeout(() =>
                            this.onIntroHoverAnchorsMouseLeave(e), 100)
                    }

                    el.addEventListener('mouseleave', onMouseLeave)
                })
            })
    }

    onIntroHoverAnchorsMouseEnter (e) {
        const media = this.getIntroMedia()

        if (!media.classList.contains('hero-intro-media-hover'))
            return

        const mediaVideo = media
            .querySelector('.hero-intro-media-container video')

        if (mediaVideo && !mediaVideo.paused)
            mediaVideo.pause()

        const target = e.target

        const hoverItem = media.querySelector(`[data-type=${target
            .getAttribute('data-type')}]`)

        const hoverVideo = hoverItem
            ? hoverItem.querySelector('video')
            : null

        if (hoverVideo && hoverVideo.paused) {
            hoverVideo.currentTime = 0
            hoverVideo.play()
        }

        if (!hoverItem.classList.contains('active'))
            hoverItem.classList.add('active')

        if (!media.classList.contains('hero-intro-media-hover-active'))
            media.classList.add('hero-intro-media-hover-active')
    }

    onIntroHoverAnchorsMouseLeave (e) {
        const target = e.target

        const hoverAnchor = this.el.querySelector(
            '.hero-intro-description a[data-type]:hover')

        if (target === hoverAnchor)
            return

        const media = this.getIntroMedia()

        const hoverItem = media.querySelector(`[data-type=${target
            .getAttribute('data-type')}]`)

        const hoverVideo = hoverItem
            ? hoverItem.querySelector('video')
            : null

        if (hoverVideo && !hoverVideo.paused)
            hoverVideo.pause()

        if (hoverItem && hoverItem.classList.contains('active'))
            hoverItem.classList.remove('active')

        if (hoverAnchor
                || (e.toElement
                    && this.getIntroHoverAnchors().indexOf(e.toElement) >= 0))
            return

        if (media.classList.contains('hero-intro-media-hover-active'))
            media.classList.remove('hero-intro-media-hover-active')

        const mediaVideo = media
            .querySelector('.hero-intro-media-container video')

        if (mediaVideo && mediaVideo.paused)
            mediaVideo.play()
    }

    getIntroHoverAnchors () {
        return Array.from(this.el
            .querySelectorAll('.hero-intro-description a[data-type]'))
    }

    getIntroMedia () {
        return this.el
            .querySelector('.hero-intro-media')
    }

    renderIntroUnderline () {
        if (!this.el.classList.contains('hero-intro'))
            return

        const underlineText = this.el
            .querySelector('.hero-intro-heading-text-emphasis')

        const underline = this.el
            .querySelector('.hero-intro-heading-text-emphasis-underline')

        const headingText = this.el.querySelector('.hero-intro-heading') || {}

        if (!headingText
                || !underline
                || !underlineText
                || this.props.introAnimation === 'end')
            return

        const headingTextWrapper = headingText.parentElement

        const headingTextWrapperCol = headingTextWrapper.parentElement

        if (underline.parentElement === underlineText)
            headingTextWrapperCol
                .appendChild(underline)

        const headingTextLastChild = headingText.lastElementChild
                && headingText.lastElementChild.classList
                    .contains('hero-intro-heading-text')
            ? headingText.lastElementChild
            : null

        const underlineTextWidth = `${underlineText.clientWidth + 1}px`

        if (underline.style.width !== underlineTextWidth)
            underline.style.width = underlineTextWidth

        const headingTextBounds = headingText.getBoundingClientRect()

        const underlineTextBounds = underlineText.getBoundingClientRect()

        const underlineTextLeft = `${21
            + (window.innerWidth >= 1024
                ? 50
                : 0)
            + (underlineTextBounds.x - headingTextBounds.x)}px`

        if (underline.style.left !== underlineTextLeft)
            underline.style.left = underlineTextLeft

        if (underline.style.left !== underlineTextLeft)
            underline.style.left = underlineTextLeft

        const headingTextWrapperColBounds = headingTextWrapperCol
            .getBoundingClientRect()

        const headingTextTransformY = parseFloat(((window
            .getComputedStyle(headingTextLastChild)
            .transform || {}) || '')
            .replace(/^.+\s(\d+)\)$/, '$1')) || 0

        const underlineHeight = (parseFloat(window
            .getComputedStyle(underline)
            .getPropertyValue('--underline-height') || '0') * 16)
            || (window.innerWidth < 1024
                ? 5
                : 10)

        const underlineTextBottom = `${
            (headingTextWrapperColBounds.bottom
                - (underlineTextBounds.bottom
                    - headingTextTransformY))
            + (underlineHeight * (window.innerWidth < 1024
                ? 1
                : 0.85))}px`

        if (underline.style.marginBottom !== underlineTextBottom)
            underline.style.marginBottom = underlineTextBottom
    }

    renderIntro () {
        if (!this.el.classList.contains('hero-intro')
                || this.props.introAnimation)
            return

        this.props.introAnimation = 'pending'

        this.renderIntroUnderline()

        const headingText = this.el.querySelector('.hero-intro-heading') || {}

        const headingTextLastChild = headingText.lastElementChild
                && headingText.lastElementChild.classList
                    .contains('hero-intro-heading-text')
            ? headingText.lastElementChild
            : null

        const underline = this.el
            .querySelector('.hero-intro-heading-text-emphasis-underline')

        const header = document.querySelector(
            '#global-header.global-header-overlay.global-header-anchors-color-inherit')

        const headerAnchors = header
            ? Array.from(header.querySelectorAll('a'))
            : []

        const headingTextAnimationEndEl = headingTextLastChild
                && underline
                && headingTextLastChild
            ? underline
            : headingTextLastChild

        const onEnd = () => setTimeout(() => {
            if (headingTextAnimationEndEl)
                headingTextAnimationEndEl
                    .removeEventListener('animationend', onEnd)

            const transitionDuration = headerAnchors.length
                    && (this.el.style.transitionDuration || '').match(/ms$/)
                ? parseFloat(this.el.style.transitionDuration)
                : 0

            if (transitionDuration)
                headerAnchors
                    .forEach((el) => {
                        el.style.transition = `color ${
                            transitionDuration}ms ease; background 300ms ease`
                    })

            if (header && header.classList.contains('white'))
                header.classList.remove('white')

            if (transitionDuration)
                headerAnchors
                    .forEach(el =>
                        setTimeout(() => {
                            el.style.transition = ''
                        }, transitionDuration))

            const media = this.getIntroMedia()

            const mediaRevealDelay = media
                ? parseFloat(media.getAttribute('data-delay') || '0')
                : 0

            const mediaVideo = media.querySelector('video')

            if (mediaVideo)
                mediaVideo.load()

            setTimeout(() => {
                if (!media)
                    return

                if (mediaVideo)
                    mediaVideo.autoplay = true

                Promise
                    .resolve(mediaVideo
                        ? (new VideoSrcsetComponent({
                            el: mediaVideo,
                            props: mediaVideo.dataset
                        }))
                        : null)
                    .then(() => {
                        media.classList.add('hero-intro-media-active')

                        if (mediaVideo)
                            mediaVideo.play()
                    })
            }, window.innerWidth >= 1024
                ? mediaRevealDelay
                : 1800)

            const description = this.el
                .querySelector('.hero-intro-description')

            if (description
                    && media
                    && !this.getFeature('touch')) {
                const onDescriptionTransitionEnd = () => {
                    description
                        .removeEventListener('transitionend',
                            onDescriptionTransitionEnd)

                    media.classList.add('hero-intro-media-hover')
                }

                description
                    .addEventListener('transitionend',
                        onDescriptionTransitionEnd)
            }

            this.props.introAnimation = 'end'
        }, 400)

        headingTextAnimationEndEl
            ? headingTextAnimationEndEl
                .addEventListener('animationend', onEnd)
            : onEnd()

        this.props.introAnimation = 'start'
    }

    render () {
        this.renderIntroUnderline()

        if (this.init)
            this.init = false
    }
}
